module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"province.label":"จังหวัด","province.placeholder":"เลือกจังหวัด","district.label":"อำเภอ/เขต","district.placeholder":"เลือกอำเภอ/เขต","subdistrict.label":"ตำบล/แขวง","subdistrict.placeholder":"เลือกตำบล/แขวง","postal_code.label":"รหัสไปรษณีย์","postal_code.placeholder":"ระบุรหัสไปรษณีย์"}}')
  delete Component.options._Ctor
}
